import { TagBox } from "devextreme-react";
import { Form, GroupItem, Label, SimpleItem } from "devextreme-react/form";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FileUploader } from "../../components";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { textEditorOptions } from "../../utils/helpers";
import { Category } from "../account/detail/tabs/product/type";
import HTMLEditor from "./HTMLEditor";
import { CreateBlog } from "./type";


const CreateBlogform = forwardRef<any, { data: CreateBlog, }>((
    { data, }, ref
) => {
    const localize = useSelector(getLocalized);
    const { token, lang } = useSelector(getApiParams);
    const [categories, setCategories] = useState<Category[]>([]);
    let tags: any = [];

    const getCategories = useCallback((async () => {
        const response: ApiResponse<Category[]> = await createRequest({
            method: "GET",
            url: "/api/dashboardview/categories",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setCategories(response.Result)
        }
    }), [token, lang])



    useEffect(() => {
        getCategories()
    }, [getCategories])

    const customCreateTag = (args: any) => {
        const newValue = args.text
        args.customItem = newValue
        tags.push(newValue)
        data.BlogTags = tags

    }
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={`ProductCategoryId`}
                label={{
                    text: localize.getString("category"),
                }}
                editorType={"dxLookup"}
                editorOptions={
                    {
                        searchEnabled: true,
                        items: categories,
                        displayExpr: "Name",
                        valueExpr: "Id",
                    }
                }
            >
            </SimpleItem>
            <SimpleItem
                dataField="Name"
                label={{
                    text: localize.getString("name")
                }}
                editorType={"dxTextBox"}
                editorOptions={{
                    inputAttr: {
                        style: " text-transform: capitalize",
                    },
                }}
            />
            <SimpleItem
                dataField="ShortContent"
                label={{
                    text: localize.getString("shortContent")
                }}

                render={(e: any) => (
                    <HTMLEditor data={data} height="200px"/>
                )}
            //editorOptions={textEditorOptions}
            />
            <SimpleItem
                dataField="Content"
                label={{
                    text: localize.getString("content")
                }}
                editorType={"dxHtmlEditor"}
                editorOptions={textEditorOptions}
            />



            <GroupItem colCount={2}>
                <SimpleItem
                    dataField={"BlogTags"}
                    label={{
                        text: localize.getString("blogTag")
                    }}
                    render={(e: any) => {
                        return <TagBox
                            items={data.BlogTags}
                            acceptCustomValue={true}
                            onCustomItemCreating={customCreateTag}
                        >
                        </TagBox>
                    }}
                >
                </SimpleItem>
                <SimpleItem
                    dataField="Image"
                >
                    <FileUploader
                        buttonText={localize.getString("selectFile")}
                        onValueChanged={(values) => {
                            (data.Image = values[0])
                        }}
                    />
                    <Label text={localize.getString("image")}></Label>
                </SimpleItem>

            </GroupItem>

        </GroupItem>
    </Form >
})

export default CreateBlogform;